import styled, { css } from "styled-components";

export const AppBarHeaderTitleRoot = styled.div(
    () => css`
        display: flex;
        align-items: center;
        gap: 5px;
    `,
);
